var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconcheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1982 5.65228C20.5265 5.90483 20.588 6.37571 20.3354 6.70403L10.9997 18.8404C10.8681 19.0115 10.6692 19.1176 10.4539 19.1316L9.63181 19.1849C9.41644 19.1989 9.20548 19.1195 9.05287 18.9669L4.3233 14.2373C4.03041 13.9444 4.03041 13.4695 4.3233 13.1766L4.67685 12.8231C4.96975 12.5302 5.44462 12.5302 5.73751 12.8231L9.29786 16.3834C9.61799 16.7035 10.1466 16.6692 10.4227 16.3104L18.7502 5.4846C19.0027 5.15629 19.4736 5.09487 19.8019 5.34742L20.1982 5.65228Z",
    fill: "#3B5118"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconcheckmark);
export default __webpack_public_path__ + "static/media/icon.checkmark.eab77713311aa2de09a64cc3d7c1f6d4.svg";
export { ForwardRef as ReactComponent };